
import { defineComponent } from 'vue';

export default defineComponent({
    name: '404',

    setup() {
        document.title = 'Page Not Found | Vue3 Blog';
    },
});
